import { dark as muiLight } from "@material-ui/core/styles/createPalette";

let light = Object.assign(muiLight, { divider: "rgba(255, 255, 255, 0.05)" });

export default light;
